import React from 'react';
import { Box,Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import EmailTemplateList from './EmailTemplateList';

const LearningPathEmailTemplate = () => {
  const { id } = useParams();
  
  return (
    <Box sx={{ p: 2 }}>
        <Typography variant="h4" gutterBottom className='page-title'>Email Templates</Typography>
        <Typography variant="body2" sx={{ mb: 4 }}>Events in your learning activity trigger emails that are sent to Learners, their Managers or the content Authors. Use the templates on this page to personalize these emails. Emails can be turned ON or OFF.
        </Typography>
        <EmailTemplateList type="learningPath" />
    </Box>    
  );
};

export default LearningPathEmailTemplate;
